import React from 'react';
import { ChevronDown, Ghost } from 'lucide-react';

export const BetHistoryToolbar = ({ tab, setTab, limit, setLimit, game }) => {
  const ghost = game.wallet.ghost ?? true;
  const changeTabWithKey = (event) => {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    const next = event.key === 'Home' ? 'my' : event.key === 'End' ? 'all' : tab === 'my' ? 'all' : 'my';
    setTab(next);
    document.getElementById(`keno-history-tab-${next}`)?.focus();
  };
  return <div className="keno-history-heading">
    <div className="keno-history-tabs" role="tablist" aria-label="Bet history view" onKeyDown={changeTabWithKey}>
      {[['my', 'My Bets'], ['all', 'All Bets']].map(([id, label]) => <button type="button" key={id} id={`keno-history-tab-${id}`} role="tab"
        aria-selected={tab === id} aria-controls="keno-history-panel" tabIndex={tab === id ? 0 : -1}
        data-testid={`keno-history-tab-${id}`} className={tab === id ? 'active' : ''} onClick={() => setTab(id)}>{label}</button>)}
    </div>
    <div className="keno-history-controls">
      {!game.demo && <button type="button" className="keno-history-privacy" data-testid="keno-ghost-mode" aria-pressed={ghost}
        aria-label={`Ghost mode ${ghost ? 'on' : 'off'}`} title={`Ghost mode ${ghost ? 'ON — your name is hidden' : 'OFF — your name is public on new bets'}`}
        disabled={game.walletLoading || game.ghostBusy || game.busy || game.auto} onClick={() => game.updateGhost(!ghost)}><Ghost size={21} aria-hidden="true" data-testid="keno-ghost-mode-icon" /></button>}
      <div className="keno-history-limit-control">
        <select aria-label="Number of bets shown" data-testid="keno-history-limit" value={limit} onChange={(event) => setLimit(Number(event.target.value))}>
          {[10, 25, 50].map((value) => <option key={value} value={value} data-testid={`keno-history-limit-${value}`}>{value}</option>)}
        </select><ChevronDown size={16} aria-hidden="true" />
      </div>
    </div>
  </div>;
};